import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { SaveRecordAction, useSearchModality } from '@aibees/elephant/hooks';
import { useMemo } from 'react';
import { config } from './config';

export function useSaveDefaultValues() {
  const { modality } = useSearchModality();

  return useMemo(() => {
    const { defaultValues } = config;
    const values = { ...defaultValues };

    // Remove EMAIL_REVERIFY completely when search modality is UNSAVED
    if (modality === SearchModality.UNSAVED) {
      delete values[SaveRecordAction.CONTACT_REVERIFY_EMAIL];
    }

    return values;
  }, [modality]);
}
